export default __webpack_public_path__ + "static/media/sz.0e54f807.svg";